import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/internal/operators/map';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './common.service';
import { BehaviorSubject } from 'rxjs';
const routes = {
  getNoti: '/notification',
  lastednotifies: '/notification/lasted',
};


@Injectable({
  providedIn: 'root'
})
export class NotifyService {

  constructor(private apiService: ApiService, private translate: TranslateService, private common: CommonService) { }

  /**
   * Get list notify for users
   */
  getNotifyList(filter: any) {
    return this.apiService.post(routes.getNoti, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Delete notify
   */
  deleteNotify(notifyId: any) {
    return this.apiService.get('/notification/delete/' + notifyId)
      .pipe(map(res => {
        return;
      }));
  }

  /**
   * Update status notify
   */
  updateStatus(notifyId: any) {
    return this.apiService.get('/notification/status/' + notifyId)
      .pipe(map(res => {
        return res;
      }));
  }

  StringFormat(str: string, ...args: string[]) {
    return str.replace(/{(\d+)}/g, (match, index) => args[index] || '')
  }


  /**
   * Get list 5 lasted notify
   */
  getLastedNotify() {
    return this.apiService.get(routes.lastednotifies);
  }

  getContent(notify) {
    // console.log("==> notify: ", notify);
    // const data = JSON.parse(notify.content)
    let time;
    let template;
    let date;
    let successTime;
    let successDate;
    let totalDocs;
    let totalSuccess;
    let toatalFail;
    let totalWait;
    switch (notify.notitficationType) {
      case 0:
      case 10:
        return this.StringFormat(notify.content, this.translate.instant('notifi-0'));
      case 1:
      case 2:
        return this.StringFormat(notify.content, this.translate.instant('notifi-1'), this.translate.instant('notifi-1-reason'));
      case 3:
      case 4:
        return this.StringFormat(notify.content, this.translate.instant('notifi-2'));
      case 7:
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-3-0')
          , this.translate.instant('notifi-3-1')
          , this.translate.instant('notifi-3-2')
          , this.translate.instant('notifi-3-3')
          , this.translate.instant('notifi-3-4')
          , this.translate.instant('notifi-3-5')
          , this.translate.instant('notifi-3-6')
          , this.translate.instant('notifi-3-7'));
      case 8:
        return this.StringFormat(notify.content, this.translate.instant('notifi-3-0')
          , this.translate.instant('notifi-3-1')
          , this.translate.instant('notifi-3-8')
          , this.translate.instant('notifi-3-3')
          , this.translate.instant('notifi-3-4')
          , this.translate.instant('notifi-3-5')
          , this.translate.instant('notifi-3-6')
          , this.translate.instant('notifi-3-9')
          , this.translate.instant('notifi-3-7'));
      case 15:
      case 116:
        return this.StringFormat(notify.content, this.translate.instant('notifi-7'));
      case 16:
      case 117:
        return this.StringFormat(notify.content, this.translate.instant('notifi-6'));
      case 17:
        return this.StringFormat(notify.content, this.translate.instant('notifi-11'));
      case 18:
        return this.StringFormat(notify.content, this.translate.instant('notifi-7-1'));
      case 19:
      case 114:
      case 118:
      case 119:
        return this.StringFormat(notify.content, this.translate.instant('notifi-15'));
      case 20:
        return this.StringFormat(notify.content, this.translate.instant('notifi-6-1'));
      case 21:
        return this.StringFormat(notify.content, this.translate.instant('notifi-6-2'));
      case 22:
        return this.StringFormat(notify.content, this.translate.instant('notifi-7-2'));
      case 23:
        return this.StringFormat(notify.content, this.translate.instant('notifi-8'));
      case 24:
        return this.StringFormat(notify.content, this.translate.instant('notifi-8-1'));
      case 25:
        return this.StringFormat(notify.content, this.translate.instant('notifi-8-2'));
      case 26:
        return this.StringFormat(notify.content, this.translate.instant('notifi-6-1'));
      case 27:
        return this.StringFormat(notify.content, this.translate.instant('notifi-7-1'));
      case 29:
        return this.StringFormat(notify.content, this.translate.instant('notifi-6-2'));
      case 30:
        return this.StringFormat(notify.content, this.translate.instant('notifi-7-2'));
      case 31:
        return this.StringFormat(notify.content, this.translate.instant('notifi-15'));
      case 32:
        return this.StringFormat(notify.content, this.translate.instant('notifi-8-1'));
      case 33:
        return this.StringFormat(notify.content, this.translate.instant('notifi-8-2'));
      case 34:
        return this.StringFormat(notify.content, this.translate.instant('notifi-16'));
      case 35:
        return this.StringFormat(notify.content, this.translate.instant('notifi-7'));
      case 36:
        return this.StringFormat(notify.content, this.translate.instant('notifi-17-1'));
      case 37:
        return this.StringFormat(notify.content, this.translate.instant('notifi-17-2'));
      case 38:
        return this.StringFormat(notify.content, this.translate.instant('notifi-18'));
      case 39:
      case 121:
        return this.StringFormat(notify.content, this.translate.instant('notifi-19'));
      case 40:
        return this.StringFormat(notify.content, this.translate.instant('notifi-20'), this.translate.instant('notifi-20-1'));
      case 41:
        return this.StringFormat(this.translate.instant('notifi-21'), notify.content);
      case 42:
        return this.StringFormat(this.translate.instant('notifi-22'), notify.content);
      case 43:
      case 44:
      case 45:
      case 46:
      case 47:
      case 48:
      case 57:
      case 58:
      case 88:
        return this.StringFormat(this.translate.instant('notifi-23'), notify.content);
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 59:
      case 60:
      case 89:
        return this.StringFormat(this.translate.instant('notifi-24'), notify.content);
      case 55:{
        const data = JSON.parse(notify.content)
        return this.translate.instant('notifi-25-0') + ' ' + data.startHour + ' '
          + this.translate.instant('notifi-25-1') + ' ' + data.startDate + ' '
          + this.translate.instant('notifi-25-2-0') + ' '
          + this.translate.instant('notifi-25-2-3') + ' ' + data.endHour + ' '
          + this.translate.instant('notifi-25-1') + ' ' + data.endDate + '<br>'
          + this.translate.instant('notifi-25-3') + '<br>'
          + this.translate.instant('notifi-25-4') + ' ' + data.totalAmount + '<br>'
          + this.translate.instant('notifi-25-5') + ' ' + data.successAmount + '<br>'
          + this.translate.instant('notifi-25-6') + ' ' + data.failAmount
      }
      case 56:
        const data = JSON.parse(notify.content)
        return this.translate.instant('notifi-25-0') + ' ' + data.startHour + ' '
          + this.translate.instant('notifi-25-1') + ' ' + data.startDate + ' '
          + this.translate.instant('notifi-25-2-1') + ' '
          + this.translate.instant('notifi-25-2-3') + ' ' + data.endHour + ' '
          + this.translate.instant('notifi-25-1') + ' ' + data.endDate + '<br>'
          + this.translate.instant('notifi-25-3') + '<br>'
          + this.translate.instant('notifi-25-4') + ' ' + data.totalAmount + '<br>'
          + this.translate.instant('notifi-25-5') + ' ' + data.successAmount + '<br>'
          + this.translate.instant('notifi-25-6') + ' ' + data.failAmount + '<br>'
          + this.translate.instant('notifi-25-7') + ' ' + data.cancelAmount
      case 84:{
        const data = JSON.parse(notify.content)
        return this.translate.instant('notifi-84-0') + ' ' + data.startHour + ' '
          + this.translate.instant('notifi-84-1') + ' ' + data.startDate + ' '
          + this.translate.instant('notifi-84-2-0') + ' '
          + this.translate.instant('notifi-84-2-3') + ' ' + data.endHour + ' '
          + this.translate.instant('notifi-84-1') + ' ' + data.endDate + '<br>'
          + this.translate.instant('notifi-84-3') + '<br>'
          + this.translate.instant('notifi-84-4') + ' ' + data.totalAmount + '<br>'
          + this.translate.instant('notifi-84-5') + ' ' + data.successAmount + '<br>'
          + this.translate.instant('notifi-84-6') + ' ' + data.failAmount
      }
      case 85:{
        const data = JSON.parse(notify.content)
        return this.translate.instant('notifi-84-0') + ' ' + data.startHour + ' '
          + this.translate.instant('notifi-84-1') + ' ' + data.startDate + ' '
          + this.translate.instant('notifi-84-2-1') + ' '
          + this.translate.instant('notifi-84-2-3') + ' ' + data.endHour + ' '
          + this.translate.instant('notifi-84-1') + ' ' + data.endDate + '<br>'
          + this.translate.instant('notifi-84-3') + '<br>'
          + this.translate.instant('notifi-84-4') + ' ' + data.totalAmount + '<br>'
          + this.translate.instant('notifi-84-5') + ' ' + data.successAmount + '<br>'
          + this.translate.instant('notifi-84-6') + ' ' + data.failAmount + '<br>'
          + this.translate.instant('notifi-84-7') + ' ' + data.cancelAmount }
      case 86:{
        const data = JSON.parse(notify.content)
        return this.translate.instant('notifi-86-0') + ' ' + data.startHour + ' '
          + this.translate.instant('notifi-86-1') + ' ' + data.startDate + ' '
          + this.translate.instant('notifi-86-2-0') + ' '
          + this.translate.instant('notifi-86-2-3') + ' ' + data.endHour + ' '
          + this.translate.instant('notifi-86-1') + ' ' + data.endDate + '<br>'
          + this.translate.instant('notifi-86-3') + '<br>'
          + this.translate.instant('notifi-86-4') + ' ' + data.totalAmount + '<br>'
          + this.translate.instant('notifi-86-5') + ' ' + data.successAmount + '<br>'
          + this.translate.instant('notifi-86-6') + ' ' + data.failAmount
      }
      case 87:{
        const data = JSON.parse(notify.content)
        return this.translate.instant('notifi-86-0') + ' ' + data.startHour + ' '
          + this.translate.instant('notifi-86-1') + ' ' + data.startDate + ' '
          + this.translate.instant('notifi-86-2-1') + ' '
          + this.translate.instant('notifi-86-2-3') + ' ' + data.endHour + ' '
          + this.translate.instant('notifi-86-1') + ' ' + data.endDate + '<br>'
          + this.translate.instant('notifi-86-3') + '<br>'
          + this.translate.instant('notifi-86-4') + ' ' + data.totalAmount + '<br>'
          + this.translate.instant('notifi-86-5') + ' ' + data.successAmount + '<br>'
          + this.translate.instant('notifi-86-6') + ' ' + data.failAmount + '<br>'
          + this.translate.instant('notifi-86-7') + ' ' + data.cancelAmount ;}
      case 92: {
        const data = JSON.parse(notify.content)
        return this.translate.instant('notifi-92-0') + ' ' + data.startHour + ' '
          + this.translate.instant('notifi-92-1') + ' ' + data.startDate + ' '
          + this.translate.instant('notifi-92-2-0') + ' '
          + this.translate.instant('notifi-92-2-3') + ' ' + data.endHour + ' '
          + this.translate.instant('notifi-92-1') + ' ' + data.endDate + '<br>'
          + this.translate.instant('notifi-92-3') + '<br>'
          + this.translate.instant('notifi-92-4') + ' ' + data.totalAmount + '<br>'
          + this.translate.instant('notifi-92-5') + ' ' + data.successAmount + '<br>'
          + this.translate.instant('notifi-92-6') + ' ' + data.failAmount
      }
      case 93: {
        const data = JSON.parse(notify.content)
        return this.translate.instant('notifi-92-0') + ' ' + data.startHour + ' '
          + this.translate.instant('notifi-92-1') + ' ' + data.startDate + ' '
          + this.translate.instant('notifi-92-2-1') + ' '
          + this.translate.instant('notifi-92-2-3') + ' ' + data.endHour + ' '
          + this.translate.instant('notifi-92-1') + ' ' + data.endDate + '<br>'
          + this.translate.instant('notifi-92-3') + '<br>'
          + this.translate.instant('notifi-92-4') + ' ' + data.totalAmount + '<br>'
          + this.translate.instant('notifi-92-5') + ' ' + data.successAmount + '<br>'
          + this.translate.instant('notifi-92-6') + ' ' + data.failAmount + '<br>'
          + this.translate.instant('notifi-92-7') + ' ' + data.cancelAmount
      }
      case 62:
        return this.StringFormat(this.translate.instant('notifi-23'), notify.content);
      case 63:
        return this.StringFormat(this.translate.instant('notifi-24'), notify.content);
      case 61: {
        return this.StringFormat(notify.content, this.translate.instant('notifi-26-1'), this.translate.instant('notifi-26-2'));
      }
      case 64: {
        return this.StringFormat(notify.content, this.translate.instant('notifi-26-1'), this.translate.instant('notifi-26-4'));
      }
      case 65:
      case 66: {
        return this.StringFormat(notify.content, this.translate.instant('notifi-27-1'), this.translate.instant('notifi-27-2'));
      }
      case 67: {
        return this.StringFormat(notify.content, this.translate.instant('notifi-28'));
      }
      case 68:
      case 69: {
        return this.StringFormat(notify.content, this.translate.instant('notifi-29'));
      }
      case 70: {
        return this.StringFormat(notify.content, this.translate.instant('notifi-30-1'), this.translate.instant('notifi-30-2'));
      }
      case 72: {
        return this.StringFormat(notify.content, this.translate.instant('notifi-72-1'), this.translate.instant('notifi-72-2'));
      }
      case 73: {
        return this.StringFormat(notify.content, this.translate.instant('notifi-73-1'), this.translate.instant('notifi-73-2'));
      }
      case 71: {
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-71-0')
          , this.translate.instant('notifi-71-1')
          , this.translate.instant('notifi-71-2')
          , this.translate.instant('notifi-71-1')
          , this.translate.instant('notifi-71-3')
          , this.translate.instant('notifi-71-4')
          , this.translate.instant('notifi-71-5')
          , this.translate.instant('notifi-71-6')
          , this.translate.instant('notifi-71-7'));
      }
      // phê duyệt theo lô
      case 75:
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-75-0')
          , this.translate.instant('notifi-75-1')
          , this.translate.instant('notifi-75-2')
          , this.translate.instant('notifi-75-3')
          , this.translate.instant('notifi-75-5')
          , this.translate.instant('notifi-75-6')
          , this.translate.instant('notifi-75-7'));
      // hủy phê duyệt theo lô
      case 76:
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-76-0')
          , this.translate.instant('notifi-76-1')
          , this.translate.instant('notifi-76-2')
          , this.translate.instant('notifi-76-3')
          , this.translate.instant('notifi-76-4')
          , this.translate.instant('notifi-76-5')
          , this.translate.instant('notifi-76-6')
          , this.translate.instant('notifi-76-7')
          , this.translate.instant('notifi-76-8')
        );
      // Từ chối phê duyệt theo lô
      case 77:
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-77-0')
          , this.translate.instant('notifi-77-1')
          , this.translate.instant('notifi-77-2')
          , this.translate.instant('notifi-77-3')
          , this.translate.instant('notifi-77-5')
          , this.translate.instant('notifi-77-6')
          , this.translate.instant('notifi-77-7')
        );
      case 82:
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-82-0')
          , this.translate.instant('notifi-82-1')
        );
      case 90:
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-90-0')
          , this.translate.instant('notifi-90-1')
          , this.translate.instant('notifi-90-2')
          , this.translate.instant('notifi-90-3')
          , this.translate.instant('notifi-90-4')
          , this.translate.instant('notifi-90-5')
          , this.translate.instant('notifi-90-6')
          , this.translate.instant('notifi-90-7'));
      case 83:
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-82-0')
          , this.translate.instant('notifi-82-1')
        );
      // ngừng từ chối phê duyệt theo lô
      case 78:
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-78-0')
          , this.translate.instant('notifi-78-1')
          , this.translate.instant('notifi-78-2')
          , this.translate.instant('notifi-78-3')
          , this.translate.instant('notifi-78-4')
          , this.translate.instant('notifi-78-5')
          , this.translate.instant('notifi-78-6')
          , this.translate.instant('notifi-78-7')
          , this.translate.instant('notifi-78-8')
        );
      case 79: {
        const data = JSON.parse(notify.content);
        return this.translate.instant('notifi-79-1') + ' ' + data.toLocaleString('en-US')
          + this.translate.instant('notifi-79-2');
      }
      case 80: {
        const data = JSON.parse(notify.content);
        return this.translate.instant('notifi-80-1') + ' ' + data.toLocaleString('en-US')
          + this.translate.instant('notifi-80-2');
      }

      case 95: {
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-95')
        );
      }

      case 96: {
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-96')
        );
      }

      case 97: {
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-97')
        );
      }
      case 98: {
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-98')
        );
      }
      case 103: {
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-103-1')
          , this.translate.instant('notifi-103-2')
        );
      }
      case 105: {
        return this.StringFormat(this.translate.instant('notifi-105'), notify.content );
      }
      case 106: {
        return this.StringFormat(this.translate.instant('notifi-106'), notify.content );
      }
      case 99:
        return this.StringFormat(notify.content
          , this.translate.instant('notifi-90-0')
          , this.translate.instant('notifi-90-1')
          , this.translate.instant('notifi-90-2')
          , this.translate.instant('notifi-90-3')
          , this.translate.instant('notifi-90-4')
          , this.translate.instant('notifi-90-5')
          , this.translate.instant('notifi-90-6')
          , this.translate.instant('notifi-90-7')
        );
      case 100:
        return this.StringFormat(notify.content, this.translate.instant('notifi-3-0')
          , this.translate.instant('notifi-3-1')
          , this.translate.instant('notifi-3-8')
          , this.translate.instant('notifi-3-3')
          , this.translate.instant('notifi-3-4')
          , this.translate.instant('notifi-3-5')
          , this.translate.instant('notifi-3-6')
          , this.translate.instant('notifi-3-9')
          , this.translate.instant('notifi-3-7')
        );
      case 107:
        return this.StringFormat(notify.content, this.translate.instant('notifi-107-0')
      );
      case 109:
        return this.translate.instant('notifi-109');
      case 114:
          return this.StringFormat(notify.content, this.translate.instant('notifi-114-0'),
          this.translate.instant('notifi-114-1')
        );
      case 115:
        return this.StringFormat(notify.content, this.translate.instant('notifi-115-0')
      );
      case 110:
        return this.translate.instant('notifi-111_1') + this.StringFormat(notify.content, this.translate.instant('notifi-111_2') );
      case 111:
        return this.translate.instant('notifi-111_1') + this.StringFormat(notify.content, this.translate.instant('notifi-111_2') );
    }

  }
}
